import { render, staticRenderFns } from "./RandomChart.vue?vue&type=template&id=16860cf1"
import script from "./RandomChart.vue?vue&type=script&lang=ts"
export * from "./RandomChart.vue?vue&type=script&lang=ts"
import style0 from "./RandomChart.vue?vue&type=style&index=0&id=16860cf1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports